export interface ApiResponse<T> {
  data: T
  error?: string
}

export interface ApiListResponse<T> {
  data: T[]
  total?: number
  page?: number
  pageSize?: number
  error?: string
}

export function isApiResponse<T>(response: unknown): response is ApiResponse<T> {
  return typeof response === 'object' && response !== null && 'data' in response
}
